export class UploadJsonModel {
    public id: any;
    public gridName: string;
    public sql: string;
    public status: string;
    public colSort: number;
    public pageName: string;
    public created_by: string;
    public created_dt: Date;
    public updated_dt: Date;
    public updated_by: string;
    public commPlanId: number;
    public salesChannel: string;
    public kpiId: number;
    public kpiName: string;
    public comment: string;
    public commPlan: string;
    public report_type: string;
    public description: string;
    public user_type: string;

    constructor() {
        this.user_type = null;
        this.description = null;
        this.id = null;
        this.gridName = null;
        this.sql = null;
        this.status = null;
        this.colSort = null;
        this.pageName = null;
        this.created_dt = null;
        this.created_by = null;
        this.updated_by = null;
        this.updated_dt = null;
        this.commPlanId = null;
        this.salesChannel = null;
        this.kpiId = null;
        this.kpiName = null;
        this.comment = null;
        this.commPlan = null;
        this.report_type = "";
    }
}
